import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Avatar } from "@material-ui/core";

import { styles } from "./person-suggestion.styles";

import { Person } from "./types";

const useStyles = makeStyles(styles);

type IPersonSuggestionProps = {
  person: Person;
};
export const PersonSuggestion = ({
  person: { name, email, isSuggested, externalImageUrl },
}: IPersonSuggestionProps) => {
  const classes = useStyles();

  const { familyName, givenName } = name;
  const fullName = `${givenName} ${familyName}`.trim();

  return (
    <div className={classes.content}>
      <Avatar alt={fullName} className={classes.avatar} src={externalImageUrl}>
        {(fullName && fullName[0]) || (email && email[0]) || null}
      </Avatar>
      <div className={classes.text}>
        <div className={classes.name}>{fullName}</div>
        <div className={classes.email}>{email}</div>
      </div>
      {isSuggested && <div className={classes.suggestedText}>Suggested</div>}
    </div>
  );
};
